import { Component, Input, OnInit } from '@angular/core';
import { AlertController, IonNav, ModalController, PopoverController } from '@ionic/angular';
import { CaseService } from 'src/app/services/case.service';
import { CommonService } from 'src/app/services/common.service';
import { ReinitService } from 'src/app/services/reinit.service';
import { Subscription } from 'rxjs';
import { CaseDetailPage } from '../case-detail/case-detail.page';
import { PaymentOptionPage } from '../payment-plan/payment-option/payment-option.page';
import { PersonalDetailPage } from '../personal-detail/personal-detail.page';
import { PaymentService } from 'src/app/services/payment.service';
import { AuthService } from 'src/app/services/auth.service';
// import { ArrangementPage } from '../arrangement/arrangement.page';
import { PaymentPlanRequestPage } from '../payment-plan-request/payment-plan-request.page';
import { PaymentPlanOptionComponent } from './payment-plan-option/payment-plan-option.component';
import { ViewPaymentPlanPage } from '../view-payment-plan/view-payment-plan.page';
import { PaymentFrequencyPage } from '../payment-plan/payment-frequency/payment-frequency.page';
import { CommunicationPreferencesComponent } from './communication-preferences/communication-preferences.component';
import { TranslateService } from '@ngx-translate/core';
import { AmountPaymentPlanPage } from '../amount-payment-plan/amount-payment-plan.page';
@Component({
  selector: 'app-account-details',
  templateUrl: './account-details.page.html',
  styleUrls: ['./account-details.page.scss'],
})
export class AccountDetailsPage implements OnInit {
  debtorDetailsSubscription: Subscription;
  caseDetailsSubscription: Subscription;
  debtorDetails;
  arr_option: any = {};
  background_url = '';
  filteredShowCases = [];
  isIRClient=false;
  isAFCSClient=false;
  isKnightClient=false;
  isOrielClient=false;
  modal;
  allowOnlyGroupArrangementForMultipleCases:boolean = false;
  disableSingleCaseRedirect = false; // Keep for backward compatibility
  termsText = '';
  disableCommunicationPreferences = false;
  redirectAfterLogin = 'no_redirect';
  groupedCases = [];
  groupCasesEnabled = false;
  unifiedPaymentOptionsLabel = '';
  unifiedPaymentOptions = false;
  arrangementMode = '';
  constructor(
    public caseService: CaseService,
    private commonService: CommonService,
    private reinitService: ReinitService,
    private ionNav: IonNav,
    public paymentService: PaymentService,
    private authService: AuthService,
    private alertController: AlertController,
    private popoverController: PopoverController,
    private modalController: ModalController,
    public translate: TranslateService,
  ) {
    this.reinitService.reinit$.subscribe((shouldReinit) => {
      if (shouldReinit) {
        this.ionViewWillEnter(); // Manually trigger component reinitialization
      }
    });
  }
  async ngOnInit() {
    const url = new URL(localStorage.getItem('server_url'));
    const subdomain = url.hostname.split('.').shift();
    this.isIRClient = subdomain === 'ir';
    this.isAFCSClient = subdomain === 'afcs';
    this.isKnightClient = subdomain === 'knight';
    this.isOrielClient = subdomain === 'oriel';
    if (localStorage.getItem('portal_settings')) {
      let settings = JSON.parse(localStorage.getItem('portal_settings'));
      if (settings?.portal_details?.background_url) {
        this.background_url = settings.portal_details.background_url;
      }
      if (settings?.portal_details?.disable_communication_preferences) {
        this.disableCommunicationPreferences = settings.portal_details.disable_communication_preferences;
      }
      //Used for allow group arrangement for multiple cases
      this.allowOnlyGroupArrangementForMultipleCases = settings.portal_details.allow_only_group_arrangement_for_multiple_cases ?? this.allowOnlyGroupArrangementForMultipleCases;

      // Backward compatibility: Check for old disable_single_case_redirect setting
      if (settings?.portal_details?.disable_single_case_redirect) {
        this.disableSingleCaseRedirect = settings.portal_details.disable_single_case_redirect;
      }

      // New redirect_after_login setting (takes precedence if present)
      if (settings?.portal_details?.redirect_after_login) {
        this.redirectAfterLogin = settings.portal_details.redirect_after_login;
      }
      this.groupCasesEnabled = settings.portal_details.enable_group_cases ?? false;

      if (settings?.unified_payment_options && settings?.unified_payment_options_label) {
        this.unifiedPaymentOptionsLabel = settings.unified_payment_options_label;
      }
      // Store the unified_payment_options flag for conditional rendering
      if (settings?.unified_payment_options) {
        this.unifiedPaymentOptions = settings.unified_payment_options;
      }

      if (settings?.arrangement?.arrangement_mode) {
        this.arrangementMode = settings.arrangement.arrangement_mode;
      }
    }
    if(!localStorage.getItem('isConsent') && !this.disableCommunicationPreferences){
      await this.openModal();
    }

    if (this.isOrielClient && this.isTrustPaymentRedirect()) {
      this.handleTrustPaymentRedirect();
    }
    //Check the case details and redirect to account page if only one case is bind to debtor.
    this.getCaseDetails();
  }
  ngOnDestroy(): void {
    if (this.debtorDetailsSubscription) {
      this.debtorDetailsSubscription.unsubscribe();
    }
  }

  isTrustPaymentRedirect(): boolean {
    const params = new URLSearchParams(window.location.search);
    return (
      params.has('requestreference') ||
      params.has('errorcode') ||
      params.has('paymenttypedescription')
    );
  }

  /**
   * Handles the redirect after a Trust Payment (Google Pay) transaction is completed
   * @returns {void}
   */
  handleTrustPaymentRedirect() {
    // Get the URL query params
    const urlParams = new URLSearchParams(window.location.search);
    // Create an object to store the response fields
    const responseFields: any = {};

    // Loop over the URL query params and store them in the responseFields object
    urlParams.forEach((value, key) => {
      if (!isNaN(Number(key))) {
        // If the key is numeric, treat it as gateway_id
        responseFields['gateway_id'] = key;
      } else {
        responseFields[key] = value;
      }
    });

    // Check if the requestreference and settlestatus are present
    if (
      responseFields['requestreference'] &&
      (responseFields['settlestatus'] == '0' || responseFields['settlestatus'] == '100')
    ) {
      // Save the Trust Payment Google Pay response to the server
      this.caseService
        .saveTrustPaymentDigitalWalletData(responseFields)
        .subscribe(async (res: any) => {
          this.commonService.dismissLoader();
          if (res.result) {
            this.commonService.showToast(res['message'], 'success');
            // Navigate back to the root page
            this.ionNav.popToRoot();
          } else {
            this.commonService.showToast(res['message'], 'danger');
          }
        });
    } else {
      // If the requestreference and settlestatus are not present, show an error message
      this.commonService.dismissLoader();
      this.commonService.showToast('Payment failed', 'danger');
    }

    // Dismiss the loader
    this.commonService.dismissLoader();

    // Optional: Clear URL query params to prevent re-submission on refresh
    window.history.replaceState({}, document.title, window.location.pathname);
  }

  getCaseTitle(caseItem,varForPopup=0){
    const clientTitle = caseItem.client?.client_title
      ?.replace(/\s*\([^)]*\)/g, '')
      ?.trim();
    if (this.isIRClient && varForPopup==0) {
      return `Original Creditor: ${caseItem.client?.client_title}`;
    } else if (this.isAFCSClient) {
      return `${caseItem.id} - ${caseItem.client?.town}`;
    } else if (this.isKnightClient) {
      return `${caseItem.client?.title}`;
    } else if (this.isOrielClient) {
      return clientTitle;
    } else {
      return `${caseItem.client?.client_title}`;
    }
  }
  ionViewWillEnter() {
    let portalSettings = JSON.parse(localStorage.getItem('portal_settings'));
    if (portalSettings?.arr_option) {
      this.arr_option = portalSettings?.arr_option
        ? portalSettings?.arr_option
        : { request: true, perform: false };
    }

    if (this.groupCasesEnabled === true && this.caseService.caseList && this.caseService.caseList.length > 0) {
      this.groupCasesByClient();
    }
  }

  async getCaseDetails() {
    this.caseDetailsSubscription = this.caseService
      .getCaseDetailsData()
      .subscribe((res: any) => {
        if (res && res.result) {
          if(Object.keys(res.data.caseList).length == 1) {
            const first = Object.keys(res.data.caseList)[0];
            let profileData = res.data.caseList[first];
            let portalSettings = JSON.parse(localStorage.getItem('portal_settings'));

            // Backward compatibility: Check if using old disable_single_case_redirect
            if (!this.disableSingleCaseRedirect && this.redirectAfterLogin == null) {
              // Old behavior: redirect to case details when disable_single_case_redirect is false
              this.ionNav.push(CaseDetailPage, { selectedProfile: profileData, portalSettings : portalSettings});
            }

            // New behavior: use redirect_after_login setting
            else if (this.redirectAfterLogin && this.redirectAfterLogin != 'no_redirect') {
              switch (this.redirectAfterLogin) {
                case 'single_case_details':
                  this.ionNav.push(CaseDetailPage, { selectedProfile: profileData, portalSettings : portalSettings});
                  break;
                case 'debtor_details':
                  console.log('debtor_details');
                  this.ionNav.push(PersonalDetailPage);
                  break;
                default:
                  break;
              }
            }
            // If disable_single_case_redirect is true (old setting) and redirect_after_login is not set or redirect_after_login is no_redirect, no redirect happens
          }

          if (this.groupCasesEnabled === true) {
            this.groupCasesByClient();
          }
        }
      });
  }

  groupCasesByClient() {
    if (!this.caseService.caseList || this.caseService.caseList.length === 0) {
      this.groupedCases = [];
      return;
    }

    const grouped = {};

    this.caseService.caseList.forEach(caseItem => {
      const clientId = caseItem.client?.id || caseItem.client_id || 'unknown';
      const clientTitle = this.getClientTitle(caseItem);

      if (!grouped[clientId]) {
        grouped[clientId] = {
          clientId: clientId,
          clientTitle: clientTitle,
          cases: [],
          totalOutstanding: 0
        };
      }

      grouped[clientId].cases.push(caseItem);

      const outstanding = this.getOutstandingBalanceValue(caseItem);
      if (outstanding > 0) {
        grouped[clientId].totalOutstanding += outstanding;
      }
    });

    this.groupedCases = Object.values(grouped);
  }

  getClientTitle(caseItem) {
    if (this.isIRClient) {
      return caseItem.client?.client_title || 'Unknown Client';
    } else if (this.isAFCSClient) {
      return caseItem.client?.town || 'Unknown Town';
    } else if (this.isKnightClient) {
      return caseItem.client?.title || 'Unknown Client';
    } else {
      return caseItem.client?.client_title || 'Unknown Client';
    }
  }

  getOutstandingBalanceValue(data) {
    if (!data.d_outstanding) return 0;

    const cleanValue = data.d_outstanding.replace(/[^\d.-]/g, '');
    const numValue = parseFloat(cleanValue);
    return isNaN(numValue) ? 0 : numValue;
  }

  getFormattedTotalOutstanding(total) {
    if (total === 0) return '-';

    const firstCase = this.caseService.caseList[0];
    const currencySymbol = firstCase?.currency_symbol || '';

    return currencySymbol + total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  disablePayButton(i){
    if (this.isAFCSClient && i !== 0) {
        return true;
    }
    return this.paymentService.paymentBtnDisabled;
  }

  getGlobalCaseIndex(caseItem) {
    return this.caseService.caseList.findIndex(c => c.id === caseItem.id);
  }

  disablePayButtonForCase(caseItem) {
    const globalIndex = this.getGlobalCaseIndex(caseItem);
    return this.disablePayButton(globalIndex);
  }

  async presentActionSheet(caseData) {
    this.paymentService.presentActionSheet(caseData);
  }

  async goToProfileDetail(profileData) {
    let portalSettings = JSON.parse(localStorage.getItem('portal_settings'));
    this.ionNav.push(CaseDetailPage, { selectedProfile: profileData, portalSettings : portalSettings});
  }

  async goToPaymentOption(caseData) {
    this.caseService.setPaymentData({
      caseId: caseData.id,
      caseData,
    });

    if (this.arrangementMode == 'amount_first') {
      this.ionNav.push(AmountPaymentPlanPage, {
        caseData,
        planType:'plan',
        debtorDetails: this.authService.debtorDetails,
      })
    } else {
      this.ionNav.push(PaymentOptionPage, {
        caseData,
        planType:'plan',
        debtorDetails: this.authService.debtorDetails,
      });
    }
  }

  async goToPaymentViewOption(caseData) {
    this.ionNav.push(ViewPaymentPlanPage, {
      caseId: caseData.id,
      currentCase: caseData,
    });
  }

  getCaseOutStanding(caseData) {
    return caseData?.d_outstanding.replace(caseData?.currency_symbol, '');
  }

  getOutstandingBalance(data) {
    if (!data.d_outstanding) return '-';
    else {
      if (isNaN(data.d_outstanding[0])) return data.d_outstanding;
      else if (data.currency_symbol) {
        return data.currency_symbol + data.d_outstanding;
      }
      return data.d_outstanding;
    }
  }

  async goToPaymentPlanProposal(caseData) {
    this.ionNav.push(PaymentPlanRequestPage, {
      caseId: caseData.id,
      totalOutstanding: caseData.d_outstanding,
      isGroupArrangement: false,
      debtorDetails: this.authService.debtorDetails,
      caseData: caseData,
    });
  }

  async presentPopover(ev: any, item: any) {
    const popover = await this.popoverController.create({
      component: PaymentPlanOptionComponent,
      componentProps: {
        case: item,
      },
      event: ev,
      translucent: true,
    });
    await popover.present();
    const { data } = await popover.onDidDismiss();
    if (data?.case && typeof this[data?.type] === 'function') {
      this[data.type](data.case);
    }
  }

  async presentUnifiedPaymentOptions(ev: any, caseData: any, caseIndex: number) {
    const alert = await this.alertController.create({
      header: this.unifiedPaymentOptionsLabel,
      message: this.generatePaymentOptionsHTML(caseData),
      cssClass: 'unified-payment-options-modal',
      buttons: [
        {
          text: this.translate.instant('COMMON.CANCEL'),
          role: 'cancel',
          handler: () => {
            return true;
          }
        }
      ]
    });

    await alert.present();

    setTimeout(() => {
      this.addPaymentOptionListeners(caseData);
    }, 100);
  }

  private addPaymentOptionListeners(caseData: any) {
    const paymentOptions = document.querySelectorAll('.payment-option');
    const optionMapping = this.createOptionMapping(caseData);

    paymentOptions.forEach((option, index) => {
      option.addEventListener('click', () => {

        const optionText = option.textContent?.trim();

        const optionType = optionMapping[optionText];

        if (optionType) {
          this.handleUnifiedPaymentOption(optionType, caseData);
          this.closeCurrentAlert();
        }
      });
    });
  }

  private createOptionMapping(caseData: any): { [key: string]: string } {
    const mapping: { [key: string]: string } = {};

    if (caseData.paymentPlanPerform && caseData.paymentPlanRequest &&
        caseData.arranagement?.current_arrangement?.length == 0 &&
        caseData.arranagement?.current_group_arrangement?.length == 0 &&
        !this.allowOnlyGroupArrangementForMultipleCases) {
      mapping[this.translate.instant('PAYMENT.PAYMENT_PLAN')] = 'paymentPlan';
    }

    if (caseData.paymentPlanRequest && !caseData.paymentPlanPerform &&
        caseData.arranagement?.current_arrangement?.length == 0) {
      mapping[this.translate.instant('PAYMENT.REQUESTED_PAYMENT_PLAN')] = 'paymentPlanProposal';
    }

    mapping[this.translate.instant('PAYMENT.PAYMENT_PLAN_OPTION.MAKE_PAYMENT_PLAN')] = 'makePaymentPlan';

    if (caseData.arranagement?.current_arrangement?.length ||
        caseData.arranagement?.current_group_arrangement?.length) {
      mapping[this.translate.instant('PAYMENT.PAYMENT_PLAN_OPTION.VIEW_PAYMENT_PLAN')] = 'viewPaymentPlan';
    }

    mapping[this.translate.instant('PAYMENT.PAY')] = 'pay';

    return mapping;
  }

  private async closeCurrentAlert() {
    try {
      const alertController = await this.alertController.getTop();
      if (alertController) {
        await alertController.dismiss();
      }
    } catch (error) {
      console.log('Error closing alert:', error);
    }
  }

  private generatePaymentOptionsHTML(caseData: any): string {
    let html = '<div class="unified-payment-options">';

    if (caseData.paymentPlanPerform && caseData.paymentPlanRequest &&
        caseData.arranagement.current_arrangement.length == 0 &&
        caseData.arranagement.current_group_arrangement.length == 0 &&
        !this.allowOnlyGroupArrangementForMultipleCases) {
      html += `<div class="payment-option" data-option="paymentPlan">
        <ion-icon name="calendar-outline"></ion-icon>
        <span>${this.translate.instant('PAYMENT.PAYMENT_PLAN')}</span>
      </div>`;
    }

    if (caseData.paymentPlanRequest && !caseData.paymentPlanPerform &&
        caseData.arranagement.current_arrangement.length == 0) {
      html += `<div class="payment-option" data-option="paymentPlanProposal">
        <ion-icon name="document-text-outline"></ion-icon>
        <span>${this.translate.instant('PAYMENT.REQUESTED_PAYMENT_PLAN')}</span>
      </div>`;
    }

    html += `<div class="payment-option" data-option="makePaymentPlan">
      <ion-icon name="card-outline"></ion-icon>
      <span>${this.translate.instant('PAYMENT.PAYMENT_PLAN_OPTION.MAKE_PAYMENT_PLAN')}</span>
    </div>`;

    if (caseData.arranagement.current_arrangement.length ||
        caseData.arranagement.current_group_arrangement.length) {
      html += `<div class="payment-option" data-option="viewPaymentPlan">
        <ion-icon name="eye-outline"></ion-icon>
        <span>${this.translate.instant('PAYMENT.PAYMENT_PLAN_OPTION.VIEW_PAYMENT_PLAN')}</span>
      </div>`;
    }

    html += `<div class="payment-option" data-option="pay">
      <ion-icon name="card-outline"></ion-icon>
      <span>${this.translate.instant('PAYMENT.PAY')}</span>
    </div>`;

    html += '</div>';
    return html;
  }

  handleUnifiedPaymentOption(optionType: string, caseData: any) {
    switch (optionType) {
      case 'paymentPlan':
        this.presentPopover(null, caseData);
        break;
      case 'paymentPlanProposal':
        this.goToPaymentPlanProposal(caseData);
        break;
      case 'makePaymentPlan':
        this.goToPaymentOption(caseData);
        break;
      case 'viewPaymentPlan':
        this.goToPaymentViewOption(caseData);
        break;
      case 'pay':
        this.presentActionSheet(caseData);
        break;
      default:
        this.commonService.showToast(this.translate.instant('PAYMENT.UNKNOWN_OPTION_TYPE'), 'danger');
        break;
    }
  }

  async GroupPlanPopover(ev:any,caseList:any){
    let caseIds = caseList.map((caseItem: any) => caseItem.id);
    let inputs;
    let showCases = caseList.filter(ele => {
      return ele.arranagement.current_arrangement.length==0;
    });

    await this.filterGroupArrangement(caseIds, showCases);
    if(this.filteredShowCases.length>0){
        inputs = this.filteredShowCases.map((c) => {
        return {
          name: 'selected_gateway',
          type: 'checkbox',
          label: this.getCaseTitle(c,1) +', '+' '+ this.translate.instant('PAYMENT.OUTSTANDING') +' : ' + c.d_outstanding,
          value: c,
          checked:true,
        };
      });
      const alert = await this.alertController.create({
        header: this.translate.instant('PAYMENT.GROUP.SELECT_ACCOUNTS_FOR_GROUP_PAYMENT'),
        inputs: inputs,
        cssClass:'custom-alert-class',
        buttons: [
          {
            text: this.translate.instant('COMMON.CANCEL'),
            role: 'cancel',
            handler: () => {},
          },
          {
            text: this.translate.instant('COMMON.CONTINUE'),
            role: 'OK',
            handler: async (selectedCases) => {
              if (!selectedCases || selectedCases.length < 2) {
              const warningAlert = await this.alertController.create({
                header: this.translate.instant('PAYMENT.GROUP.SELECTION_ERROR'),
                message: this.translate.instant('PAYMENT.GROUP.SELECTION_ERROR_MESSAGE'),
                buttons: ['OK'],
              });
              await warningAlert.present();
              return false;
            }
              this.caseService.setPaymentData({
                caseData : selectedCases,
                paymentOption:'paymentPlan'
              });
              if (this.arrangementMode == 'amount_first') {
                this.ionNav.push(AmountPaymentPlanPage, {
                  caseData : selectedCases,
                  planType : 'group_plan',
                  debtorDetails: this.authService.debtorDetails,
                })
              } else {
                this.ionNav.push(PaymentFrequencyPage, {
                  caseData : selectedCases,
                  planType : 'group_plan',
                  debtorDetails: this.authService.debtorDetails,
                });
              }
            },
          },
        ],
      });
      await alert.present();
    }
    else if(this.filteredShowCases.length ==0){
    const alert = await this.alertController.create({
      header: this.translate.instant('PAYMENT.GROUP.SELECT_ACCOUNTS_FOR_GROUP_PAYMENT'),
      message: this.translate.instant('PAYMENT.GROUP.ALL_CASES_HAVE_GROUP_ARRANGEMENT'),


      cssClass:'custom-alert-class',
      buttons: [
        {
          text: this.translate.instant('COMMON.OK'),
          role: 'OK',
        },
      ],
    });
    await alert.present();

  }

    }

  async filterGroupArrangement(caseIds , showCases){
    return new Promise<void>((resolve, reject) => {
    this.caseService.getGroupArrangement(caseIds).subscribe((res: any) => {
      if (res.result && res.data?.group_arrangement_cases) {
        this.filteredShowCases = showCases.filter(showCase => !res.data.group_arrangement_cases.includes(showCase.id));
       }
       else{
        this.filteredShowCases = showCases;
       }
       resolve();
      } ,
       error =>{
        reject(error);

     });
  });
}

  async openModal() {
    const modal = await this.modalController.create({
      component: CommunicationPreferencesComponent,
    });
    await modal.present();

    const { data, role } = await modal.onWillDismiss();
  }

  async openAlertForNewPaymentPlan(caseDetails) {
    const alert = await this.alertController.create({
      message: this.translate.instant('PAYMENT.CREATE_NEW_PAYMENT_PLAN_MESSAGE'),
      buttons: [
        {
          text: this.translate.instant('COMMON.CANCEL'),
          role: 'cancel',
          handler: () => {},
        },
        {
          text: this.translate.instant('COMMON.CONTINUE'),
          role: 'OK',
          handler: async (res) => {
            await this.goToPaymentOption(caseDetails);
          },
        },
      ]
    });

    await alert.present();
  }
}
